module.exports = __webpack_public_path__ + "a768e7de/img/boston-lights.a623432f.png";